var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignatureLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100.28 100.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#ffce00;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lager_1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 100.28,
    height: 100.28,
    rx: 15.82,
    ry: 15.82
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m25.68,73.05l7.16-10.19c4.31,4.5,11.02,8.35,19.46,8.35,7.25,0,10.65-3.21,10.65-6.79,0-10.65-35.25-3.21-35.25-26.25,0-10.19,8.81-18.63,23.22-18.63,9.73,0,17.81,2.94,23.87,8.54l-7.25,9.73c-4.96-4.59-11.57-6.7-17.81-6.7-5.51,0-8.63,2.39-8.63,6.06,0,9.64,35.16,3.12,35.16,25.98,0,11.2-8.08,19.64-24.51,19.64-11.84,0-20.29-3.95-26.07-9.73Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignatureLogo);
export default __webpack_public_path__ + "static/media/signature_logo.ca01192a4f2bf421920f5b08102e11aa.svg";
export { ForwardRef as ReactComponent };